import api from '@/client/axiosInstance';
import axios from 'axios';
import { AdminRoute } from '@/constants';
import { Group } from '@/types';

const handleError = (error: unknown, message: string): never => {
  if (axios.isAxiosError(error)) {
    throw new Error(
      `${message}: ${error.response?.data?.message || error.message}`,
    );
  }
  throw new Error(`${message}: Unknown error occurred`);
};

export const getGroups = async (): Promise<Group[]> => {
  try {
    const response = await api.get(AdminRoute.groups);
    return response.data ?? [];
  } catch (error) {
    return handleError(error, 'Error fetching groups');
  }
};

// TCX-507: public broker-group list (no admin prefix) — powers the consultant
// sign-up + My Profile selectors so they reflect the managed Groups collection
// (created/renamed groups appear; deleted groups are no longer selectable).
export const getPublicGroups = async (): Promise<Group[]> => {
  try {
    const response = await api.get('groups');
    return response.data ?? [];
  } catch (error) {
    return handleError(error, 'Error fetching groups');
  }
};

export const createGroup = async (name: string): Promise<Group> => {
  try {
    const response = await api.post(AdminRoute.groups, { name });
    return response.data;
  } catch (error) {
    return handleError(error, 'Error creating group');
  }
};

export const updateGroup = async (id: string, name: string): Promise<Group> => {
  try {
    const response = await api.patch(AdminRoute.updateGroup(id), { name });
    return response.data;
  } catch (error) {
    return handleError(error, 'Error updating group');
  }
};

export const deleteGroup = async (id: string) => {
  try {
    const response = await api.delete(AdminRoute.deleteGroup(id));
    return response.data;
  } catch (error) {
    return handleError(error, 'Error deleting group');
  }
};
